export const DEFAULT_CATALOG_NAME = {
  name_4: "NIST 800-53rev4",
  name_5: "NIST 800-53rev5",
};
export const DEFAULT_CATALOG_STANDARD = {
  standard_4: "NIST-800-53rev4",
  standard_5: "NIST-800-53rev5",
};
